export default {
  '系统默认样式': '系统默认样式',
  '重打印': '重打印',
  '店铺编号print': '店铺编号',
  '单据日期': '单据日期',
  '核销单号print': '核销单号',
  '定金单号': '定金单号',
  '小票号print': '小票号',
  '操作时间print': '操作时间',
  '收银员print': '收银员',
  '营业员print': '营业员',
  '店铺电话print': '店铺电话',
  '店铺手机print': '店铺手机',
  '会员编号print': '会员编号',
  '会员姓名print': '会员姓名',
  '会员等级print': '会员等级',
  '销售备注print': '销售备注',
  '店铺地址print': '店铺地址',
  '已中所有促销': '已中所有促销',
  '已中整单促销': '已中整单促销',
  '总额print': '总额',
  '优惠print': '优惠',
  '应付print': '应付',
  '找零': '找零',
  '积分': '积分',
  '支付流水号': '支付流水号',
  '获得积分print': '获得积分',
  '积分余额print': '积分余额',
  '储值余额print': '储值余额',
  '代用券券号': '代用券券号',
  '顾客签名': '顾客签名',
  '该单所有的促销': '该单所有的促销',
  '促销描述': '促销描述',
  '货品print': '货品',
  '吊牌价print': '吊牌价',
  '会员价': '会员价',
  '折后价print': '折后价',
  '零售折扣/折后价': '零售折扣/折后价',
  '零售价print': '零售价',
  '零售折扣print': '零售折扣',
  '折扣/折后价': '折扣/折后价',
  '折扣print': '折扣',
  '数量print': '数量',
  '金额print': '金额',
  '合计print': '合计',
  '会员print': '会员',
  '顾客联': '顾客联',
  '店铺联': '店铺联',
  '税额/金额': '税额/金额',
  '税额': '税额',
  '代用券': '代用券',
  '不限': '不限',
  '满-金额': '满',
  '可用': '可用',
  '店铺': '店铺',
  '番禺区城店': '番禺区城店',
  '广州市番禺区天安节能科技园15号楼': '广州市番禺区天安节能科技园15号楼',
  '买满送优惠券': '买满送优惠券',
  '买满打折(按货品)': '买满打折(按货品)',
  '买满立减(按单)': '买满立减(按单)',
  '王晓': '王晓',
  '快递费': '快递费',
  '金属感香槟灰': '金属感香槟灰',
  '长袖上衣': '长袖上衣',
  'FS OTH 男装运动套头衫': 'FS OTH 男装运动套头衫',
  '现金支付': '现金支付',
  '高级会员': '高级会员',
  '方某某': '方某某',
  '张三': '张三',
  '日期': '日期'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/preview.js